import { CheckoutState } from '../../state';
import { hasCannedQuestions, hasCustomQuestions } from './pureSelectors';

export const hasQuestions = (state: CheckoutState) =>
    hasCannedQuestions(state) || hasCustomQuestions(state);
